import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import TotalReturnTracker from "@/pages/TotalReturnTracker";
import AuthCallback from "@/pages/AuthCallback";
import PublicWatchlist from "@/pages/PublicWatchlist";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // Synchronous check (NOT in useEffect) - handle Emergent auth callback before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<TotalReturnTracker />} />
      <Route path="/w/:id" element={<PublicWatchlist />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain-overlay">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      <Toaster
        theme="system"
        position="bottom-right"
        toastOptions={{
          // Sonner already applies role="status" by default; error toasts use role="alert" + aria-live="assertive".
          style: {
            background: "var(--toaster-bg, #121214)",
            border: "1px solid var(--toaster-border, #27272A)",
            borderRadius: 0,
            fontFamily: "Chivo, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
